// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-form {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 0.5rem;
}

section {
  display: flex;
}

.mat-mdc-checkbox {
  align-self: center;
}

.search-bar {
  grid-column: span 5;
}
.search-bar .mat-mdc-form-field {
  width: 100%;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm5ldy1wcm9wdWxzaW9uLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsYUFBQTtFQUNBLHFDQUFBO0VBQ0EsZ0JBQUE7QUFDRjs7QUFFQTtFQUNFLGFBQUE7QUFDRjs7QUFFQTtFQUNFLGtCQUFBO0FBQ0Y7O0FBRUE7RUFDRSxtQkFBQTtBQUNGO0FBQUU7RUFDRSxXQUFBO0FBRUoiLCJmaWxlIjoibmV3LXByb3B1bHNpb24uY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIubmV3LWZvcm0ge1xuICBkaXNwbGF5OiBncmlkO1xuICBncmlkLXRlbXBsYXRlLWNvbHVtbnM6IHJlcGVhdCg1LCAxZnIpO1xuICBncmlkLWdhcDogMC41cmVtO1xufVxuXG5zZWN0aW9uIHtcbiAgZGlzcGxheTogZmxleDtcbn1cblxuLm1hdC1tZGMtY2hlY2tib3gge1xuICBhbGlnbi1zZWxmOiBjZW50ZXI7XG59XG5cbi5zZWFyY2gtYmFyIHtcbiAgZ3JpZC1jb2x1bW46IHNwYW4gNTtcbiAgLm1hdC1tZGMtZm9ybS1maWVsZCB7XG4gICAgd2lkdGg6IDEwMCU7XG4gIH1cbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/components/new-propulsion/new-propulsion.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,qCAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,mBAAA;AACF;AAAE;EACE,WAAA;AAEJ;AACA,wwBAAwwB","sourcesContent":[".new-form {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  grid-gap: 0.5rem;\n}\n\nsection {\n  display: flex;\n}\n\n.mat-mdc-checkbox {\n  align-self: center;\n}\n\n.search-bar {\n  grid-column: span 5;\n  .mat-mdc-form-field {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
